export default {
      id: "driver-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.svg#driver",
      toString: function () {
        return this.url;
      }
    }